import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './FanArt.css';

const posts = [
  { author: 'Izakoi_N2P', id: '2099036779840262452' },
  { author: 'pbhtIN3TJ283798', id: '2092276674360725873' },
  { author: 'pha_co0Lbe4uty', id: '2085411605668594126', suffix: '/photo/1' },
  { author: 'anna_san_dayo', id: '2094006128552403372' },
  { author: 'asmrchurch', id: '1968481353172652124' },
  { author: 'antibullybully', id: '2088850779474157827' },
  { author: 'fkpwsf', id: '2086857084826738834' },
  { author: 'fkpwsf', id: '2085200335321309553' },
  { author: 'Uooooooo_VRC', id: '2082813951180779688' },
];

function FanArt() {
  const galleryRef = useRef(null);

  useEffect(() => {
    const gallery = galleryRef.current;
    const renderPosts = () => window.twttr?.widgets?.load(gallery);
    let script = document.querySelector('script[src="https://platform.twitter.com/widgets.js"]');
    if (!script) {
      script = document.createElement('script');
      script.src = 'https://platform.twitter.com/widgets.js';
      script.async = true;
      document.body.appendChild(script);
    }
    script.addEventListener('load', renderPosts);
    renderPosts();
    return () => script.removeEventListener('load', renderPosts);
  }, []);

  return (
    <div className="body">
      <Header
        title="みんなのファンアート - ASMRキリスト教会"
        description="みんなのFAをご紹介。X・pixivに投稿された作品をお楽しみください。"
        url="https://www.asmrchurch.com/fanart"
      />
      <main className="fanart-page">
        <Link className="fanart-back" to="/">← ホーム</Link>
        <header className="fanart-intro">
          <span className="fanart-eyebrow">FAN ART</span>
          <h1>みんなのファンアート</h1>
          <p>みんなが描いてくれた作品を紹介するお♡<br />素敵なファンアートをありがとう、君たちに神の祝福がたっぷり注ぎますように✝</p>
          <p>(もしかしたら一部拾い忘れてるかもしれん）もし描いてくれた人で抜けてたらDMかリプで教えてちょ。</p>
        </header>
        <div className="fanart-grid" ref={galleryRef}>
          {posts.map(({ author, id, suffix = '' }) => {
            const url = `https://x.com/${author}/status/${id}${suffix}`;
            return (
              <article className="fanart-card" key={id} aria-label={`@${author}の投稿`}>
                <div className="fanart-card-heading"><span>X</span><span>@{author}</span></div>
                <div className="fanart-embed">
                  <blockquote className="twitter-tweet" data-conversation="none" data-dnt="true" data-lang="ja" data-theme="light">
                    <a href={url} target="_blank" rel="noopener noreferrer">@{author}の投稿をXで見る</a>
                  </blockquote>
                </div>
                <a className="fanart-source" href={url} target="_blank" rel="noopener noreferrer">Xで元の投稿を見る ↗</a>
              </article>
            );
          })}
          <article className="fanart-card" aria-label="pixivの作品">
            <div className="fanart-card-heading"><span>pixiv</span><span>イラスト</span></div>
            <div className="fanart-embed">
              <iframe
                className="fanart-pixiv"
                title="pixivのファンアート（作品149494663）"
                src="https://embed.pixiv.net/oembed_iframe.php?type=illust&id=149494663"
                loading="lazy"
                allowFullScreen
              />
            </div>
            <a className="fanart-source" href="https://www.pixiv.net/artworks/149494663" target="_blank" rel="noopener noreferrer">pixivで元の作品を見る ↗</a>
          </article>
        </div>
        <p className="fanart-note">作品が表示されない場合は、各カードのリンクから元の投稿をご覧ください。</p>
      </main>
      <Footer />
    </div>
  );
}

export default FanArt;
